import type { ElementType, ReactElement } from "react";

import { cx, styled } from "simplydo/react/styled";

import { StyledHeaderCell, widthPct } from "./Table.styles";
import type { TableHeaderCellProps } from "./Table.types";

const TableHeaderCellComponent = ({
  as,
  active,
  collapsing,
  children,
  disabled,
  error,
  negative,
  positive,
  warning,
  selectable: _selectable,
  singleLine,
  textAlign,
  verticalAlign,
  width,
  className,
  style,
  colSpan,
  rowSpan,
  onClick,
  ...rest
}: TableHeaderCellProps): ReactElement => {
  const Component = (as || "th") as ElementType;
  const pct = widthPct(width);
  return (
    <StyledHeaderCell
      as={Component}
      className={cx(
        className,
        collapsing && "is-collapsing",
        singleLine && "is-single-line",
        active && "is-active",
        negative && "is-negative",
        positive && "is-positive",
        warning && "is-warning",
        error && "is-error",
        disabled && "is-disabled",
      )}
      style={style}
      $textAlign={textAlign}
      $verticalAlign={verticalAlign}
      $widthPct={pct}
      colSpan={colSpan}
      rowSpan={rowSpan}
      onClick={onClick}
      {...(rest as object)}
    >
      {children}
    </StyledHeaderCell>
  );
};

export const TableHeaderCell = styled(TableHeaderCellComponent)``;
